import { TranslateService } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';
import { Message } from 'primeng/primeng';

@Component({
    selector: 'app-message',
    templateUrl: './message.component.html',
    styleUrls: ['./message.component.css']
})
export class MessageComponent implements OnInit {

    msgs: Message[] = [];

    constructor(private translateService: TranslateService) {}

    ngOnInit() {}

    translate = (key: string) => this.translateService.instant(key || "invalid");

    success(message = 'success_save_message', time = 2500) {
        this.msgs.push({
            severity: 'success', 
            summary: this.translate('success'),
            detail: this.translate(message)
        });

        this.autoClear(time);
    }

    warn(message = 'requisition_failures_message', time = 2500) {
        this.msgs.push({
            severity: 'warn', 
            summary: this.translate('warning'),
            detail: this.translate(message)
        });

        this.autoClear(time);
    }

    info(message = 'success_save_message', time = 2500) {
        this.msgs.push({
            severity: 'info', 
            summary: this.translate('success'),
            detail: this.translate(message)
        });

        this.autoClear(time);
    }

    fixedInfo(message = 'success_save_message') {
        this.msgs.push({
            severity: 'info', 
            summary: this.translate('success'),
            detail: this.translate(message)
        });

    }

    error(message = 'contact_support_message', time = 5000) {
        this.msgs.push({
            severity: 'error', 
            summary: this.translate('error'),
            detail: this.translate(message)
        });

        this.autoClear(time);
    }

    clear() {
        this.msgs.splice(-1, 1);
    }

    autoClear = (time: number) => setTimeout(() => {
        this.msgs.splice(-1, 1); 
    }, time);
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/component/message/message.component.ts